"use client";
import React, {useEffect, useState} from "react";
import styles from "../redeem.module.css";
import AddressCom, {AddressData} from "@/app/(redeem)/components/AddressCom/AddressCom";
import BigTips from "@/Master/BigTips";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {RedeemConfirmDialogFC} from "@/app/(redeem)/UI/RedeemConfirmDialogFC";
import {RedeemAccountDialogFC} from "@/app/(redeem)/redeemAccount/RedeemAccountDialogFC";
import {countryListData, getCountryData} from "@/app/(redeem)/components/AddressCom/AddressComConfig";
import {DriveUtil} from "@/Master/DriveUtil";
import KitAPI from "@/Fwk/Kit/KitAPI";
import TrackRedeem from "@/Core/Track/TrackRedeem";
import {useAppSelector} from "@/app/storeHooks";
import {selectUserInfo} from "@/app/userSlice";
import Util from "@/Master/Util";
import RedeemUtil from "@/Core/Redeem/RedeemUtil";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import WebRedeem from "@/Core/Redeem/WebRedeem";
import {confJson} from "@/app/config/confJson";
import {getUserId} from "@/app/utils/auth";
import AccountInfoPyaPal from "@/app/(redeem)/redeemAccount/AccountInfoPyaPal";
import AccountInfoCom from "@/app/(redeem)/redeemAccount/AccountInfoCom";
import {RedeemChannelType} from "@/Core/Redeem/RedeemChannelType";
import AccountInfoCard from "@/app/(redeem)/redeemAccount/AccountInfoCard";
import AccountInfoCashApp from "@/app/(redeem)/redeemAccount/AccountInfoCashApp";
import {HttpResponse} from "@/Fwk/Http/HttpConfig";
import EventManager from "@/Fwk/EventManager";
import {RedeemCashOutDialogFC} from "@/app/(redeem)/redeemCashOut/RedeemCashOutDialogFC";

export type RedeemAccountUIProps = {
    channelData: ResponseRedeemConfigData,//渠道类型信息在这里
    channelCheckData: ResponseRedeemChannelCheckData //渠道帐号地址信息在这里
}

const RedeemAccountUI: React.FC<RedeemAccountUIProps> = (props) => {
    const {channelData} = props;

    const [channelCheckData, setChannelCheckData] = useState(props.channelCheckData);
    const [account, setAccount] = useState('');
    const [cAccount, setCAccount] = useState('');
    const [accountIsOk, setAccountIsOk] = useState<boolean>(false);
    const [cardToken, setCardToken] = useState('');//银行卡专用

    //首次进入页初始化地址信息
    let address = {} as AddressData;
    address.country = channelCheckData.country;
    address.state = channelCheckData.state;
    address.city = channelCheckData.city;
    address.zipCode = channelCheckData.zipCode;

    const [addressData, setAddressData] = useState<AddressData>(address);
    const userInfo = useAppSelector(selectUserInfo);

    useEffect(() => {
        updateChannelCheckData();
        EventManager.addOnEnterListener(onEnter);
        return () => {
            EventManager.removeOnEnterListener(onEnter);
        };
    }, []);

    const onEnter = () => {
        updateChannelCheckData();
    }

    useEffect(() => {
        if (Util.isLog) {
            console.log('初始化兑换输入配置页面1 => 用户信息', userInfo);
            console.log('初始化兑换输入配置页面2 => XTG配置数据', channelData);
            console.log('初始化兑换输入配置页面3 => Check数据', channelCheckData);
        }
    }, [channelCheckData]);

    const updateChannelCheckData = async () => {
        const {channelType} = channelData;
        const response = await WebRedeem.Instance.RequestRedeemChannelCheck(channelType, (data: HttpResponse<ResponseRedeemChannelCheckData>) => {
            if (Util.isLog) {
                console.log('CheckRedeemConfig', data);
            }
        });
        if (response?.code == 200){
            setChannelCheckData(response.data);
        }else{
            const msg = response?.message || response?.description;
            if (msg){
                BigTips.showMsg(msg);
            }
        }

    }

    const onBtnClickRedeemAccount = () => {
        if (!accountIsOk) {
            TrackRedeem.redeem_account_fail_show(2, addressData?.zipCode);
            BigTips.showMsg('Wrong account');
            return;
        }
        if (cAccount != account) {
            TrackRedeem.redeem_account_fail_show(3, addressData?.zipCode);
            BigTips.showMsg('Account does not match');
            return;
        }
        if (channelData.channelType == RedeemChannelType.Card){
            if (!cardToken){//银行卡绑定错误
                BigTips.showMsg('Bank card binding error');
                return;
            }
        }
        if (!addressData?.country) {
            TrackRedeem.redeem_account_fail_show(7, addressData?.zipCode);
            BigTips.showMsg('Unrecognized Country! Please Retype.')
            return;
        }
        if (!addressData?.state) {
            TrackRedeem.redeem_account_fail_show(5, addressData?.zipCode);
            BigTips.showMsg('Unrecognized State/Province! Please Retype.')
            return;
        }
        if (!addressData?.city) {
            TrackRedeem.redeem_account_fail_show(6, addressData?.zipCode);
            BigTips.showMsg('Unrecognized city! Please Retype.')
            return;
        }
        // let countryCode = `${UtilBrowser.getSystemCountry}`.toUpperCase();
        let countryCode = addressData.countryCode;
        if (!addressData?.zipCode || !DriveUtil.VerifyZipCode(addressData?.zipCode, countryCode)) {
            TrackRedeem.redeem_account_fail_show(4, addressData?.zipCode);
            BigTips.showMsg('Error Code! Please Retype.')
            return;
        }

        //TODO UI不对，把邮箱和支付方式传进去核对 调整确定页面
        SDialogManagerFC.openDialog(RedeemConfirmDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(RedeemConfirmDialogFC),
            account: account,
            channelType: channelData.channelType,
            onClose: (isOk: boolean) => {
                if (isOk) {
                    OnOkSubmit();
                }
            }
        });
    }

    const OnOkSubmit = async () => {
        const {channelType} = channelData;
        TrackRedeem.redeem_account_click(channelType);
        showForceLoading();
        const sendData = {} as RequestBindWithdrawAccountData;
        sendData.city = addressData.city;
        sendData.country = addressData.country;
        sendData.province = addressData.state;
        sendData.state = addressData.state;
        sendData.zipCode = addressData.zipCode;
        sendData.productId = `${confJson.productId}`;
        sendData.showAccount = account;//展示提现账户(银行卡提现渠道类型)
        sendData.userId = getUserId();

        if (channelType == RedeemChannelType.Card){
            sendData.withdrawAccount = cardToken;//银行卡使用token验证
        }else{
            sendData.withdrawAccount = account;//用户提现账户
        }

        sendData.channelType = channelType;//渠道类型
        const requestRes = await WebRedeem.Instance.RequestBindWithdrawAccount(sendData);
        if (requestRes?.code == 200){
            //关闭兑换帐号页面
            SDialogManagerFC.closeDialogFC(RedeemAccountDialogFC);
            //todo 直接跳转去提现输入页面
            //直接进入提现输入页面
            SDialogManagerFC.openDialog(RedeemCashOutDialogFC, {
                fcKey: SDialogManagerFC.getFCKey(RedeemCashOutDialogFC),
                channelData:channelData,
                channelCheckData:channelCheckData,
                onClose: (isOk: boolean) => {
                }
            });
        }else{
            const msg = requestRes?.message || requestRes?.description;
            if (msg){
                BigTips.showMsg(msg)
            }
        }
        hideForceLoading();
    }

    const onCallAccountInfo = (a:string,b:string,isOk:boolean) => {
        setAccount(a);
        setCAccount(b);
        setAccountIsOk(isOk);
        if (Util.isLog){
            console.log('onCallAccountInfo',a,b,isOk);
        }
    }

    const onCallCardInfo = (a:string,b:string,isOk:boolean) => {
        setAccount(a);
        setCAccount(a);
        setCardToken(b);
        setAccountIsOk(isOk);
        if (Util.isLog){
            console.log('onCallCardInfo',a,b,isOk);
        }
    }

    const getOutImgName = () => {
        return `c_out_${RedeemUtil.getChannelTypeName(channelData.channelType)}`;
    }

    const getInputCom = () => {
        const {channelType} = channelData;
        switch (channelType) {
            case RedeemChannelType.Card:
                return (<AccountInfoCard data={props} onCallInfo={onCallCardInfo}/>)
            case RedeemChannelType.Paypal:
                return (<AccountInfoPyaPal data={props} onCallInfo={onCallAccountInfo}/>)
            case RedeemChannelType.CashApp:
                return (<AccountInfoCashApp data={props} onCallInfo={onCallAccountInfo}/>)
            // case RedeemChannelType.ApmAch:
            //     break;
            // case RedeemChannelType.ApmMazooma:
            //     break;
            default:
               return (<AccountInfoCom data={props} onCallInfo={onCallAccountInfo}/>);
        }
    }

    return (
        <>
            <div className={styles.redeem_account_wrapper}>
                <section className={styles.section}>
                    <form>
                        {/* 支付方式选择 */}
                        <div className={`${styles.listLogo} center`}>
                            <img src={`/img/redeem/${getOutImgName()}.webp`} alt={getOutImgName()}/>
                        </div>

                        {/* 信息输入 */}
                        {getInputCom()}

                        {/* 地址信息输入 */}
                        <div className={`${styles.content} ${styles.addressBox} `}>
                            <div className={`center ${styles.eTitle}`}>Your Billing Address</div>
                            <AddressCom initData={addressData} onChange={(data) => {
                                setAddressData(data)
                            }}/>
                        </div>

                        {/* 提交按钮 */}
                        <button type="button" className={`btn ${styles.btn}`} onClick={onBtnClickRedeemAccount}>Confirm
                        </button>

                    </form>
                </section>
            </div>
        </>
    )
}

export default RedeemAccountUI;